// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html {
  font-size: 1rem;
  margin: 0;
  padding: 0;
  font-family: "Inter", Arial, Helvetica, sans-serif;
}

body {
  margin: 0;
  background: linear-gradient(180deg, hsl(200, 25%, 8%), hsl(200, 30%, 5%));
  color: hsl(180, 15%, 92%);
  font-family: "Inter", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: hsl(190, 70%, 45%);
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.siteWrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss","webpack://./src/styles/partials/_variables.scss"],"names":[],"mappings":"AAIA;EACI,sBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,kDCPQ;ADKZ;;AAKA;EACI,SAAA;EACA,yECQY;EDPZ,yBCNQ;EDOR,kDCdQ;EDeR,mCAAA;EACA,kCAAA;AAFJ;;AAKA;EACI,yBCXY;EDYZ,qBAAA;AAFJ;AAII;EACI,0BAAA;AAFR;;AAMA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAHJ","sourcesContent":["@use \"./partials/mixins\" as *;\n@use \"./partials/variables\" as *;\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500;600&display=swap\");\n\n* {\n    box-sizing: border-box;\n}\n\nhtml {\n    font-size: 1rem;\n    margin: 0;\n    padding: 0;\n    font-family: $font-body;\n}\n\nbody {\n    margin: 0;\n    background: $gradient-dark;\n    color: $colour-fg;\n    font-family: $font-body;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na {\n    color: $colour-accent;\n    text-decoration: none;\n\n    &:hover {\n        text-decoration: underline;\n    }\n}\n\n.siteWrapper {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    padding: 0;\n}\n","$breakpoint-mobile: 320px;\n$breakpoint-tablet: 480px;\n$breakpoint-desktop: 768px;\n\n$font-display: \"Bebas Neue\", sans-serif;\n$font-body: \"Inter\", Arial, Helvetica, sans-serif;\n\n$radius-card: 1rem;\n$radius-pill: 2rem;\n$radius: 0.75rem;\n\n$colour-bg: hsl(200, 25%, 8%);\n$colour-fg: hsl(180, 15%, 92%);\n$colour-surface: hsl(200, 20%, 12%);\n$colour-accent: hsl(190, 70%, 45%);\n$colour-accent-light: hsl(185, 75%, 55%);\n$colour-accent-dark: hsl(195, 65%, 35%);\n$colour-surface-alt: hsl(200, 20%, 18%);\n$colour-muted: hsl(200, 15%, 20%);\n$colour-muted-fg: hsl(200, 10%, 55%);\n$colour-border: hsl(200, 15%, 22%);\n$colour-error: hsl(0, 70%, 50%);\n$colour-error-light: hsl(0, 70%, 60%);\n\n$gradient-ocean: linear-gradient(135deg, hsl(195, 65%, 35%), hsl(190, 70%, 45%), hsl(185, 75%, 55%));\n$gradient-dark: linear-gradient(180deg, hsl(200, 25%, 8%), hsl(200, 30%, 5%));\n\n$shadow-ocean: 0 4px 30px -10px hsl(190, 70%, 45%, 0.4);\n$shadow-card: 0 10px 40px -15px hsl(0, 0%, 0%, 0.5);\n$shadow-error: 0 4px 20px -5px hsl(0, 70%, 50%, 0.6);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
